module.exports = __webpack_public_path__ + "static/media/filter_zh.073d6a12.png";